import { render, staticRenderFns } from "./user-login.component.vue?vue&type=template&id=70535192&scoped=true&"
import script from "./user-login.component.ts?vue&type=script&lang=ts&"
export * from "./user-login.component.ts?vue&type=script&lang=ts&"
import style0 from "./user-login.component.scss?vue&type=style&index=0&id=70535192&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70535192",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VBtn,VCard,VForm})
